import styled from 'styled-components';
import { breakpoints, touchFeedback } from '../../../styles/brand';

export const Container = styled.div`
  ${touchFeedback}

  padding: 2.38rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.md}) {
    padding: 1rem;
  }
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e2e2;

  h1 {
    font-family: 'RedHatDisplay-ExtraBold';
    color: #1e88e5;
    font-size: 1.8rem;
    line-height: 2.2rem;
    flex: 1;
  }

  > .primary-button {
    width: 13rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #fff;
    line-height: 1.28rem;
    padding: 0.77rem 1rem;
    border-radius: 0.55rem;
    min-width: 10.57rem;
    min-height: 2.82rem;
    box-shadow: 0px 3px 6px rgba(255, 159, 0, 0.3);
  }

  @media (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;

    h1 {
      font-size: 1.3rem;
      line-height: 1.7rem;
    }

    > .primary-button {
      width: 100%;
      min-width: unset;
      font-size: 0.95rem;
      order: 3;
    }
  }
`;

export const TournamentList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  gap: 2rem;

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
    gap: 1rem;
  }
`;

export const MainCard = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  @media (max-width: ${breakpoints.md}) {
    padding: 1rem;
    border-radius: 0.75rem;
  }
`;

export const MainCardContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  align-items: flex-start;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }
`;

export const TrophyImageWrapper = styled.div`
  flex: 0 0 16.25rem;
  width: 16.25rem;
  height: 16.25rem;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: visible;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: relative;
    z-index: 2;
  }

  svg {
    z-index: 1;
  }

  @media (max-width: ${breakpoints.md}) {
    flex: unset;
    align-self: center;
    width: 6rem;
    height: 6rem;
  }
`;

export const TournamentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const TournamentTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.6rem;
  color: #323232;
  margin: 0;

  @media (max-width: ${breakpoints.md}) {
    font-size: 1.2rem;
    text-align: center;
  }
`;

export const TournamentMeta = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;

  strong {
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
  }

  @media (max-width: ${breakpoints.md}) {
    font-size: 0.8rem;
    text-align: center;
  }
`;

export const ModalitiesLabel = styled.p`
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.9rem;
  color: #323232;
  margin: 0;
`;

export const ModalitiesRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: ${breakpoints.md}) {
    gap: 0.6rem;
  }
`;

export const ModalityCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  border: 2px solid #ff9800;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  background: #fff;
  min-width: 11.25rem;

  @media (max-width: ${breakpoints.md}) {
    min-width: unset;
    width: 100%;
    padding: 0.6rem 0.75rem;
    gap: 0.6rem;
  }
`;

export const ModalityImage = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  object-fit: contain;

  @media (max-width: ${breakpoints.md}) {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const ModalityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ModalityName = styled.span`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: #323232;
`;

export const ModalityMeta = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.78rem;
  color: #6b7280;
`;

export const CategoryBadgeRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.35rem;
`;

export const CategoryBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #dbeafe;
  color: #1e88e1;
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
  font-size: 0.72rem;
  font-family: 'RedHatDisplay-Medium';
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;

  .primary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0px 3px 8px rgba(255, 152, 0, 0.3);
  }

  .secondary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    border: 1.5px solid #1e88e5;
    color: #1e88e5;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .secondary-button {
    &:hover {
      color: #4caf50;
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    gap: 0.6rem;

    .primary-button,
    .secondary-button {
      width: 100%;
      justify-content: center;
      height: 3rem;
      font-size: 1rem;
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border: 3px solid #e0e0e0;
  border-top-color: #ff9800;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

/** Posição do status do torneio no card; o visual vem do StatusPill. */
export const StatusSlot = styled.div`
  display: flex;

  @media (max-width: ${breakpoints.md}) {
    justify-content: center;
  }
`;
